export enum DtwinConfigurationType {
  GLOBAL_AND_SPECIFIC = "GLOBAL-SPECIFIC",
  SELF_SUPPORTED = "SELF-SUPPORTED",
}
